import apiActiveTenant from "../api/ActiveTenantAPI"

const search = async (params) => {
    try {
        const result = await apiActiveTenant.search(params)
        if (result) {
            return result
        } else return []

    } catch (err) {
        throw err
    }
}

const save = async (params) => {
    try {
        const result = await apiActiveTenant.save(params)
        return result

    } catch (err) {
        throw err
    }
}

const update = async (params) => {
    try {
        const result = await apiActiveTenant.update(params)
        return result

    } catch (err) {
        throw err
    }
}

const getById = async (params) => {
    try {
        const result = await apiActiveTenant.getById(params)
        return result

    } catch (err) {
        throw err
    }
}

const getByRoomId = async (params) => {
    try {
        const result = await apiActiveTenant.getByRoomId(params)
        return result

    } catch (err) {
        throw err
    }
}

const getByEmail = async (params) => {
    try {
        const result = await apiActiveTenant.getByEmail(params)
        return result

    } catch (err) {
        throw err
    }
}

const getByHash = async (hashKey) => {
    try {
        const result = await apiActiveTenant.getByHash(hashKey)
        return result

    } catch (err) {
        throw err
    }
}

const getTRPendingCount = async (params) => {
    try {
        const result = await apiActiveTenant.getTRPendingCount(params)
        return result

    } catch (err) {
        throw err
    }
}

const downloadActiveTenantList = async (params) => {
    try {
        const result = await apiActiveTenant.downloadActiveTenantList(params)
        return result

    } catch (err) {
        throw err
    }
}

const quickSearchActiveRoom = async (params) => {
    try {
        const result = await apiActiveTenant.quickSearchActiveRoom(params)
        return result

    } catch (err) {
        throw err
    }
}

const quickSearchActiveTenant = async (params) => {
    try {
        const result = await apiActiveTenant.quickSearchActiveTenant(params)
        return result

    } catch (err) {
        throw err
    }
}

const checkout = async (params) => {
    try {
        const result = await apiActiveTenant.checkout(params)
        return result

    } catch (err) {
        throw err
    }
}

const saveTenancyRenewal = async (params) => {
    try {
        const result = await apiActiveTenant.saveTenancyRenewal(params)
        return result

    } catch (err) {
        throw err
    }
}

const updateTenancyRenewal = async (params) => {
    try {
        const result = await apiActiveTenant.updateTenancyRenewal(params)
        return result

    } catch (err) {
        throw err
    }
}

const renewRequestCount = async (params) => {
    try {
        const result = await apiActiveTenant.renewRequestCount(params)
        return result

    } catch (err) {
        throw err
    }
}

const endDateCount = async (params) => {
    try {
        const result = await apiActiveTenant.endDateCount(params)
        return result

    } catch (err) {
        throw err
    }
}

const scheduleCheckOutDate = async (params) => {
    try {
        const result = await apiActiveTenant.scheduleCheckOutDate(params)
        return result

    } catch (err) {
        throw err
    }
}

const checkUpcomingRecord = async (params) => {
    try {
        const result = await apiActiveTenant.checkUpcomingRecord(params)
        return result

    } catch (err) {
        throw err
    }
}

export default {
    search: search,
    save: save,
    update: update,
    getById: getById,
    getByRoomId: getByRoomId,
    getByEmail: getByEmail,
    getByHash: getByHash,
    getTRPendingCount: getTRPendingCount,
    downloadActiveTenantList: downloadActiveTenantList,
    quickSearchActiveRoom: quickSearchActiveRoom,
    quickSearchActiveTenant: quickSearchActiveTenant,
    checkout: checkout,
    saveTenancyRenewal: saveTenancyRenewal,
    updateTenancyRenewal: updateTenancyRenewal,
    renewRequestCount: renewRequestCount,
    endDateCount: endDateCount,
    scheduleCheckOutDate: scheduleCheckOutDate,
    checkUpcomingRecord: checkUpcomingRecord
}